module.exports = __webpack_public_path__ + "media/images/cliparts/Start-fc6d391adef77c0cabaf8f7bf7d8ab51.svg";